// Configuración del menú principal del CRM.
// Fuente única de verdad: tanto el sidebar como el buscador global la consumen.

export type NavSubItem = {
  name: string;
  path: string;
  pro?: boolean;
  new?: boolean;
  // Item visible pero no clickeable (módulo planeado, ruta aún no implementada)
  disabled?: boolean;
  // Código(s) del módulo de permisos (contacts, companies, ...). Si está presente,
  // el sidebar oculta el subítem cuando el rol no tiene canView sobre ese módulo.
  // Con un array la semántica es Y LÓGICA: hacen falta TODOS los módulos.
  moduleCode?: string | string[];
  // Herramienta técnica/avanzada: el sidebar la oculta salvo que el usuario active
  // el "Modo avanzado". Solo se usa hoy en la sección Automatización.
  advanced?: boolean;
};

export type NavItem = {
  name: string;
  icon: string;
  path?: string;
  new?: boolean;
  subItems?: NavSubItem[];
  disabled?: boolean;
  // Código(s) del módulo de permisos. Si está presente, el sidebar oculta el ítem
  // cuando el rol no tiene canView sobre ese módulo. Ítems sin moduleCode quedan visibles.
  // Con un array la semántica es Y LÓGICA: hacen falta TODOS los módulos. Se usa en la
  // sección Configuración, donde un catálogo exige a la vez 'settings' (poder tocar la
  // configuración de la empresa) y el módulo de la entidad que configura.
  moduleCode?: string | string[];
  // Herramienta técnica/avanzada: el sidebar oculta el ítem (o grupo) salvo que el
  // usuario active el "Modo avanzado". Solo se usa hoy en la sección Automatización.
  advanced?: boolean;
};

export type MenuSection = {
  title: string;
  prefix: string;
  items: NavItem[];
  rotateIcon?: boolean;
};

// ============================================================
// Iconos SVG inline (compartidos por sidebar)
// ============================================================
export const MENU_ICONS = {
  contacto: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 2C4.84315 2 3.5 3.34315 3.5 5V19C3.5 20.6569 4.84315 22 6.5 22H17.5C19.1569 22 20.5 20.6569 20.5 19V5C20.5 3.34315 19.1569 2 17.5 2H6.5ZM5 5C5 4.17157 5.67157 3.5 6.5 3.5H17.5C18.3284 3.5 19 4.17157 19 5V19C19 19.8284 18.3284 20.5 17.5 20.5H6.5C5.67157 20.5 5 19.8284 5 19V5ZM12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 9.88071 10.6193 11 12 11C13.3807 11 14.5 9.88071 14.5 8.5C14.5 7.11929 13.3807 6 12 6ZM8 8.5C8 6.29086 9.79086 4.5 12 4.5C14.2091 4.5 16 6.29086 16 8.5C16 10.7091 14.2091 12.5 12 12.5C9.79086 12.5 8 10.7091 8 8.5ZM7.25 15C7.25 14.5858 7.58579 14.25 8 14.25H16C16.4142 14.25 16.75 14.5858 16.75 15C16.75 15.4142 16.4142 15.75 16 15.75H8C7.58579 15.75 7.25 15.4142 7.25 15ZM8 17.25C7.58579 17.25 7.25 17.5858 7.25 18C7.25 18.4142 7.58579 18.75 8 18.75H13C13.4142 18.75 13.75 18.4142 13.75 18C13.75 17.5858 13.4142 17.25 13 17.25H8Z" fill="currentColor"></path></svg>`,
  empresa: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM6 5C5.44772 5 5 5.44772 5 6V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V6C19 5.44772 18.5523 5 18 5H6ZM7 8C7 7.44772 7.44772 7 8 7H16C16.5523 7 17 7.44772 17 8C17 8.55228 16.5523 9 16 9H8C7.44772 9 7 8.55228 7 8ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13H13C13.5523 13 14 12.5523 14 12C14 11.4477 13.5523 11 13 11H8ZM7 16C7 15.4477 7.44772 15 8 15H11C11.5523 15 12 15.4477 12 16C12 16.5523 11.5523 17 11 17H8C7.44772 17 7 16.5523 7 16Z" fill="currentColor"></path></svg>`,
  lead: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 3C2.44772 3 2 3.44772 2 4V20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20V4C22 3.44772 21.5523 3 21 3H3ZM4 5V19H20V5H4ZM7 8C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H7ZM6 13C6 12.4477 6.44772 12 7 12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H7C6.44772 14 6 13.5523 6 13ZM7 16C6.44772 16 6 16.4477 6 17C6 17.5523 6.44772 18 7 18H11C11.5523 18 12 17.5523 12 17C12 16.4477 11.5523 16 11 16H7Z" fill="currentColor"/></svg>`,
  negocio: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 2C8.44772 2 8 2.44772 8 3V4H7C5.89543 4 5 4.89543 5 6V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V6C19 4.89543 18.1046 4 17 4H16V3C16 2.44772 15.5523 2 15 2C14.4477 2 14 2.44772 14 3V4H10V3C10 2.44772 9.55228 2 9 2ZM7 6H17V8H7V6ZM7 10V20H17V10H7ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H15C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12H9ZM8 17C8 16.4477 8.44772 16 9 16H12C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18H9C8.44772 18 8 17.5523 8 17Z" fill="currentColor"></path></svg>`,
  tarea: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM5 5H19V19H5V5ZM16.7071 9.79289C17.0976 10.1834 17.0976 10.8166 16.7071 11.2071L11.2071 16.7071C10.8166 17.0976 10.1834 17.0976 9.79289 16.7071L7.29289 14.2071C6.90237 13.8166 6.90237 13.1834 7.29289 12.7929C7.68342 12.4024 8.31658 12.4024 8.70711 12.7929L10.5 14.5858L15.2929 9.79289C15.6834 9.40237 16.3166 9.40237 16.7071 9.79289Z" fill="currentColor"/></svg>`,
  ticket: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5C3 3.34315 4.34315 2 6 2H18C19.6569 2 21 3.34315 21 5V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5ZM5 5V19H19V5H5ZM7.25 8C7.25 7.58579 7.58579 7.25 8 7.25H16C16.4142 7.25 16.75 7.58579 16.75 8C16.75 8.41421 16.4142 8.75 16 8.75H8C7.58579 8.75 7.25 8.41421 7.25 8Z" fill="currentColor"/></svg>`,
  cotizacion: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 2C7.89543 2 7 2.89543 7 4V5H6C4.89543 5 4 5.89543 4 7V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V7C20 5.89543 19.1046 5 18 5H17V4C17 2.89543 16.1046 2 15 2H9ZM9 4H15V6H9V4ZM6 7H18V19H6V7ZM8 10C8 9.44772 8.44772 9 9 9H15C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H9C8.44772 11 8 10.5523 8 10ZM9 13C8.44772 13 8 13.4477 8 14C8 14.5523 8.44772 15 9 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H9Z" fill="currentColor"></path></svg>`,
  reunion: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 4.34315 4.34315 3 6 3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6ZM5 6C5 5.44772 5.44772 5 6 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V6ZM7.25 8C7.25 7.58579 7.58579 7.25 8 7.25H16C16.4142 7.25 16.75 7.58579 16.75 8C16.75 8.41421 16.4142 8.75 16 8.75H8C7.58579 8.75 7.25 8.41421 7.25 8Z" fill="currentColor"/></svg>`,
  segmento: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/></svg>`,
  inbox: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16a2 2 0 012 2v10a2 2 0 01-2 2H7l-3 3V6a2 2 0 012-2z" fill="currentColor"/></svg>`,
  llamada: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.6 10.8a15.1 15.1 0 006.6 6.6l2.2-2.2a1 1 0 011-.24c1.1.37 2.3.57 3.6.57a1 1 0 011 1V21a1 1 0 01-1 1C10.3 22 2 13.7 2 3a1 1 0 011-1h3.5a1 1 0 011 1c0 1.3.2 2.5.57 3.6a1 1 0 01-.24 1l-2.2 2.2z" fill="currentColor"/></svg>`,
  whatsapp: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.946C.16 5.335 5.495 0 12.05 0c3.181 0 6.167 1.24 8.413 3.488a11.82 11.82 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.51 5.26L3.51 19.05l1.144 1.143z"/></svg>`,
  chatflow: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6.75A2.75 2.75 0 016.75 4h10.5A2.75 2.75 0 0120 6.75v10.5A2.75 2.75 0 0117.25 20H6.75A2.75 2.75 0 014 17.25V6.75zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v2.5h13v-2.5c0-.69-.56-1.25-1.25-1.25H6.75zm11.25 5.25h-13v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5zM7.5 12.5h4a.75.75 0 010 1.5h-4a.75.75 0 010-1.5zm0 3h6.5a.75.75 0 010 1.5H7.5a.75.75 0 010-1.5z" fill="currentColor"/></svg>`,
  correo: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2H4zm0 2h16l-8 5-8-5zm0 2.236l8 5 8-5V18H4V8.236z" fill="currentColor"/></svg>`,
  productoBox: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25a1 1 0 00-.45.106L4.55 5.856A1 1 0 004 6.75v10.5a1 1 0 00.55.894l7 3.5a1 1 0 00.9 0l7-3.5A1 1 0 0020 17.25V6.75a1 1 0 00-.55-.894l-7-3.5A1 1 0 0012 2.25zM6 8.118l5 2.5v8.264l-5-2.5V8.118zm7 10.764v-8.264l5-2.5v8.264l-5 2.5zM12 4.118l4.764 2.382L12 8.882 7.236 6.5 12 4.118z" fill="currentColor"/></svg>`,
  categoria: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 7a2 2 0 012-2h4l2 3h8a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V7zm2 0v11h14V10h-6.586L10.586 7H5z" fill="currentColor"/></svg>`,
  bundle: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2L1 8l11 6 9-4.91V17h2V8L12 2zm0 12.06L4.32 9.85 12 5.66l7.68 4.19L12 14.06zM4 12.31v3l8 4.36 8-4.36v-3l-8 4.36-8-4.36z" fill="currentColor"/></svg>`,
  precio: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 3h9l9 9-9 9-9-9V3zm2 2v6.586l7 7L18.586 12 11.586 5H5zm3 4a2 2 0 100-4 2 2 0 000 4z" fill="currentColor"/></svg>`,
  descuento: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5l-12 12L7 18.41 19 6.41zM7 9a2 2 0 100-4 2 2 0 000 4zm10 6a2 2 0 100 4 2 2 0 000-4z" fill="currentColor"/></svg>`,
  config: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C11.4477 1 11 1.44772 11 2V2.29933C9.82098 2.58696 8.74806 3.15944 7.85774 3.93853L7.60042 3.78853C7.12304 3.51239 6.51863 3.67578 6.24249 4.15316L5.24249 5.84684C4.96635 6.32422 5.12974 6.92863 5.60712 7.20477L5.86088 7.35248C5.62567 7.99949 5.5 8.69555 5.5 9.42C5.5 10.1444 5.62567 10.8405 5.86088 11.4875L5.60712 11.6352C5.12974 11.9114 4.96635 12.5158 5.24249 12.9932L6.24249 14.6868C6.51863 15.1642 7.12304 15.3276 7.60042 15.0515L7.85774 14.9015C8.74806 15.6806 9.82098 16.253 11 16.5407V16.84C11 17.3923 11.4477 17.84 12 17.84C12.5523 17.84 13 17.3923 13 16.84V16.5407C14.179 16.253 15.2519 15.6806 16.1423 14.9015L16.3996 15.0515C16.877 15.3276 17.4814 15.1642 17.7575 14.6868L18.7575 12.9932C19.0336 12.5158 18.8703 11.9114 18.3929 11.6352L18.1391 11.4875C18.3743 10.8405 18.5 10.1444 18.5 9.42C18.5 8.69555 18.3743 7.99949 18.1391 7.35248L18.3929 7.20477C18.8703 6.92863 19.0336 6.32422 18.7575 5.84684L17.7575 4.15316C17.4814 3.67578 16.877 3.51239 16.3996 3.78853L16.1423 3.93853C15.2519 3.15944 14.179 2.58696 13 2.29933V2C13 1.44772 12.5523 1 12 1ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z" fill="currentColor"/></svg>`,
  business: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3h16a1 1 0 011 1v17a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1zm2 4h12v2H6V7zm0 4h12v2H6v-2zm0 4h8v2H6v-2z" fill="currentColor"/></svg>`,
  user: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2a5 5 0 100 10 5 5 0 000-10zM4 20a8 8 0 0116 0v1H4v-1z" fill="currentColor"/></svg>`,
  invitacion: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 8a2 2 0 012-2h14a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm2 0v9h14V8H5zm3 2a1 1 0 000 2h8a1 1 0 100-2H8zm0 4a1 1 0 000 2h5a1 1 0 100-2H8zM15 3a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0V7h-1a1 1 0 110-2h1V4a1 1 0 011-1z" fill="currentColor"/></svg>`,
  moneda: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none"><path d="M12 2C7 2 3 4 3 7v10c0 3 4 5 9 5s9-2 9-5V7c0-3-4-5-9-5zm0 2c4.42 0 7 1.79 7 3s-2.58 3-7 3-7-1.79-7-3 2.58-3 7-3zm0 14c-4.42 0-7-1.79-7-3V9c1.64 1.21 4.36 2 7 2s5.36-.79 7-2v6c0 1.21-2.58 3-7 3z" fill="currentColor"/></svg>`,
  auditoria: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9 2a1 1 0 00-1 1v1H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2V3a1 1 0 10-2 0v1h-4V3a1 1 0 00-1-1zM6 6h12v14H6V6zm2 3a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H9zm-1 5a1 1 0 011-1h4a1 1 0 110 2H9a1 1 0 01-1-1z" fill="currentColor"/></svg>`,
  metricas: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 3v18h18v-2H5V3H3zm4 12h2v-6H7v6zm4 0h2V7h-2v8zm4 0h2v-4h-2v4z" fill="currentColor"/></svg>`,
  formulario: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor"><path d="M9 2a2 2 0 00-2 2v1H6a2 2 0 00-2 2v13a2 2 0 002 2h12a2 2 0 002-2V7a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H9zm0 2h6v2H9V4zm-1 6h8v2H8v-2zm0 4h8v2H8v-2z"/></svg>`,
  automation: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 3a1 1 0 10-2 0v1.07A7.002 7.002 0 005.07 11H4a1 1 0 100 2h1.07A7.002 7.002 0 0011 18.93V20a1 1 0 102 0v-1.07A7.002 7.002 0 0018.93 13H20a1 1 0 100-2h-1.07A7.002 7.002 0 0013 4.07V3zm-1 3a5 5 0 100 10A5 5 0 0012 6zm0 2a3 3 0 110 6 3 3 0 010-6zm0 1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" fill="currentColor"/></svg>`,
  webhook: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M10 4a4 4 0 014 4 1 1 0 11-2 0 2 2 0 10-3.83.8l3.13 4.93a1 1 0 11-1.7 1.04L6.4 9.84A4 4 0 0110 4zM6.5 13.5a3.5 3.5 0 113.42 3.5h-5a1 1 0 110-2h5a1.5 1.5 0 10-1.43-1.04 1 1 0 11-1.9.62 3.5 3.5 0 01-.09-1.08zM17.5 9a3.5 3.5 0 11-3.4 4.4l-2.41 3.7a1 1 0 01-1.68-1.1l3.06-4.7a1 1 0 01.65-.43A1.5 1.5 0 1017.5 11a1 1 0 010-2z"/></svg>`,
  workflow: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 4a2 2 0 012-2h3a2 2 0 012 2v2h2V5a3 3 0 013-3h2a3 3 0 013 3v2a3 3 0 01-3 3h-2a3 3 0 01-3-3v-1h-2v8h2v-1a3 3 0 013-3h2a3 3 0 013 3v2a3 3 0 01-3 3h-2a3 3 0 01-3-3v-1h-2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 0v2h3V4H6zm10 1a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1V5zm0 12a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z" fill="currentColor"/></svg>`,
  dashboard: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 012-2h5a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm2 0v5h5V5H5zm9-2a2 2 0 00-2 2v3a2 2 0 002 2h5a2 2 0 002-2V5a2 2 0 00-2-2h-5zm0 2h5v3h-5V5zM3 16a2 2 0 012-2h5a2 2 0 012 2v3a2 2 0 01-2 2H5a2 2 0 01-2-2v-3zm2 0v3h5v-3H5zm9-3a2 2 0 00-2 2v5a2 2 0 002 2h5a2 2 0 002-2v-5a2 2 0 00-2-2h-5zm0 2h5v5h-5v-5z" fill="currentColor"/></svg>`,
  reporte: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8.414a2 2 0 00-.586-1.414l-4.414-4.414A2 2 0 0013.586 2H6zm0 2h7v4a2 2 0 002 2h3v10H6V4zm9 .414L17.586 7H15V4.414zM8 13a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H9z" fill="currentColor"/></svg>`,
  landing: `<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 5a2 2 0 012-2h12a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm2 0v3h12V5H6zm12 5H6v9h12v-9zm-9 2a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zm0 3a1 1 0 011-1h2a1 1 0 110 2h-2a1 1 0 01-1-1z" fill="currentColor"/></svg>`,
};

// ============================================================
// Secciones del menú
// ============================================================

export const SALES_ITEMS: NavItem[] = [
  { name: 'Contactos', path: '/contactos/kanban', icon: MENU_ICONS.contacto, moduleCode: 'contacts' },
  { name: 'Empresas', path: '/empresas', icon: MENU_ICONS.empresa, moduleCode: 'companies' },
  { name: 'Leads', path: '/leads', icon: MENU_ICONS.lead, moduleCode: 'leads' },
  { name: 'Negocios', path: '/deals', icon: MENU_ICONS.negocio, moduleCode: 'deals' },
  { name: 'Segmentos', path: '/segmentos', icon: MENU_ICONS.segmento, moduleCode: 'segments' },
  {
    name: 'Cotizaciones',
    icon: MENU_ICONS.cotizacion,
    moduleCode: 'quotes',
    subItems: [
      { name: 'Cotizaciones', path: '/cotizaciones' },
      { name: 'Plantillas de Cotización', path: '/cotizaciones/plantillas' },
      { name: 'Plantillas de Contenido', path: '/cotizaciones/plantillas-contenido' },
      { name: 'Responsables de aprobación', path: '/cotizaciones/responsables' },
    ],
  },
  {
    name: 'Productos',
    icon: MENU_ICONS.productoBox,
    moduleCode: 'products',
    subItems: [
      { name: 'Productos', path: '/productos' },
      { name: 'Categorías', path: '/categorias-producto' },
      { name: 'Paquetes', path: '/bundles' },
      { name: 'Listas de Precios', path: '/productos/listas-precios' },
      { name: 'Reglas de Descuento', path: '/productos/reglas-descuento' },
      // Inc 37: la pantalla existía pero no era alcanzable desde el menú.
      { name: 'Tipos de Cambio', path: '/productos/tipos-cambio' },
    ],
  },
  {
    name: 'Agendador de Reuniones',
    icon: MENU_ICONS.reunion,
    moduleCode: 'meetings',
    subItems: [
      { name: 'Reuniones', path: '/meeting' },
      { name: 'Calendario', path: '/meeting/calendar' },
      { name: 'Páginas de reserva', path: '/meeting/booking-links' },
    ],
  },
  { name: 'Tareas', path: '/tareas', icon: MENU_ICONS.tarea, moduleCode: 'tasks' },
];

export const COMMUNICATION_ITEMS: NavItem[] = [
  {
    name: 'Bandeja de entrada',
    icon: MENU_ICONS.correo,
    moduleCode: 'mail',
    subItems: [
      { name: 'Mensajes', path: '/correo' },
      { name: 'Correos enviados', path: '/correo/enviados' },
      { name: 'Canales', path: '/correo/canales' },
    ],
  },
  {
    name: 'WhatsApp',
    icon: MENU_ICONS.whatsapp,
    moduleCode: 'whatsapp',
    subItems: [
      { name: 'Chat', path: '/whatsapp/chat' },
      { name: 'Plantillas', path: '/whatsapp/plantillas' },
      { name: 'Configuración', path: '/whatsapp/setup' },
      // Herramienta destructiva restringida a Admin/Super Admin (regla dura por path en
      // MenuVisibilityService, igual que /whatsapp/setup).
      { name: 'Limpieza de contactos', path: '/whatsapp/limpieza-contactos' },
    ],
  },
  {
    name: 'Llamadas',
    icon: MENU_ICONS.llamada,
    moduleCode: 'calls',
    subItems: [
      { name: 'Historial', path: '/call' },
      { name: 'Métricas', path: '/call/metrics' },
      { name: 'Configuración Twilio', path: '/call/config' },
      { name: 'Números telefónicos', path: '/call/phone-numbers' },
    ],
  },
  {
    name: 'Invitaciones',
    icon: MENU_ICONS.invitacion,
    // InvitationController e InvitationTemplateController gatean con el módulo 'users'.
    moduleCode: 'users',
    subItems: [
      { name: 'Invitaciones', path: '/invitations' },
      { name: 'Plantillas', path: '/invitation-templates' },
    ],
  },
];

export const MARKETING_ITEMS: NavItem[] = [
  {
    name: 'Correos',
    icon: MENU_ICONS.correo,
    moduleCode: 'campaigns',
    subItems: [
      { name: 'Correo', path: '/marketing-email/estado' },
      // Las plantillas de correo tienen módulo propio ('templates', V192): un rol
      // puede gestionar campañas sin poder tocar las plantillas, y al revés.
      { name: 'Plantillas', path: '/templates', moduleCode: 'templates' },
    ],
  },
  {
    name: 'Formularios',
    icon: MENU_ICONS.formulario,
    moduleCode: 'forms',
    subItems: [
      { name: 'Formularios', path: '/marketing-forms' },
      { name: 'Plantillas', path: '/marketing-forms/plantillas' },
    ],
  },
  {
    name: 'Chat Widget',
    icon: MENU_ICONS.chatflow,
    moduleCode: 'chatflows',
    subItems: [
      { name: 'Chatflows', path: '/chatflows' },
      { name: 'Equipos de chat', path: '/chatflows/equipos' },
        { name: 'Plantillas', path: '/chatflows/plantillas' },
      { name: 'Bandeja de Agente', path: '/agent/conversations' },
      { name: 'Métricas Knowledge', path: '/chatflows/knowledge-metrics' },
    ],
  },
  {
    name: 'Landing Pages',
    icon: MENU_ICONS.landing,
    disabled: true,
  },
];

export const AUTOMATION_ITEMS: NavItem[] = [
  {
    // Lo cotidiano: crear y organizar workflows. Siempre visible.
    name: 'Workflows',
    icon: MENU_ICONS.workflow,
    moduleCode: 'workflows',
    subItems: [
      { name: 'Workflows', path: '/automation/workflows' },
      { name: 'Carpetas', path: '/automation/workflow-folders' },
    ],
  },
  {
    // Herramientas técnicas de operación (colas, webhooks, probadores).
    // Grupo íntegramente avanzado: solo aparece con "Modo avanzado" encendido.
    // Nota: probar un workflow/paso ya se hace dentro del constructor; estos
    // probadores quedan como utilidades avanzadas, no se eliminan sus rutas.
    name: 'Operación',
    icon: MENU_ICONS.config,
    moduleCode: 'workflows',
    advanced: true,
    subItems: [
      // Colas
      { name: 'Cola de Esperas', path: '/automation/workflow-waits/queue' },
      { name: 'Cola de Eventos', path: '/automation/workflow-events/queue' },
      // Webhooks
      { name: 'Endpoints Webhook', path: '/automation/workflow-webhooks/endpoints' },
      { name: 'Probar Webhooks', path: '/automation/workflow-actions/webhook-test' },
      // Probadores de acciones
      { name: 'Probar Acciones', path: '/automation/workflow-actions/test' },
      { name: 'Probar Acciones CRM', path: '/automation/workflow-actions/crm-test' },
      { name: 'Probar Actividades', path: '/automation/workflow-actions/activity-test' },
      { name: 'Probar Pipeline', path: '/automation/workflow-actions/pipeline-test' },
    ],
  },
];

export const SERVICE_ITEMS: NavItem[] = [
  { name: 'Tickets', path: '/tickets', icon: MENU_ICONS.ticket, moduleCode: 'tickets' },
];

export const ANALYTICS_ITEMS: NavItem[] = [
  { name: 'Dashboard Ejecutivo', path: '/dashboard', icon: MENU_ICONS.dashboard },
  { name: 'Reportes Personalizados', icon: MENU_ICONS.reporte, disabled: true },
];

// Sección Configuración.
//
// Su visibilidad la decide LA MATRIZ, no el nombre del rol. Hasta ahora
// MenuVisibilityService.canSeeConfigSection() escondía la sección entera a todo
// el que no fuera Admin/Super Admin (INC_CRM_024 inc03), lo que dejaba muertos
// permisos concedidos de verdad: V196 dio 'users' a Manager para que atendiera
// las altas y V204 le da 'audit', pero el menú los ocultaba igualmente.
//
// Para que quitar esa regla no destape los catálogos a media empresa, cada
// grupo de catálogos exige a la vez 'settings' (la configuración de la propia
// empresa, que solo tienen Admin y Super Admin) y el módulo de la entidad que
// configura. Resultado por rol: Admin/Super Admin todo; Manager solo Usuarios y
// Auditoría; Sales Rep y User no ven la sección (queda sin ítems y se oculta).
export const CONFIG_ITEMS: NavItem[] = [
  {
    name: 'Config. Contactos',
    icon: MENU_ICONS.config,
    moduleCode: ['settings', 'contacts'],
    subItems: [
      { name: 'Estados', path: '/config-contactos/estados' },
      { name: 'Orígenes', path: '/config-contactos/origenes' },
      { name: 'Ciclos', path: '/config-contactos/ciclos' },
      { name: 'Definición de Atributos', path: '/config-contactos/definiciones' },
      { name: 'Atributos', path: '/config-contactos/atributos' },
      { name: 'Reglas de Ciclo', path: '/config-contactos/reglas' },
    ],
  },
  {
    name: 'Config. Empresas',
    icon: MENU_ICONS.config,
    moduleCode: ['settings', 'companies'],
    subItems: [
      { name: 'Estados', path: '/config-empresas/estados' },
      { name: 'Ciclos', path: '/config-empresas/ciclos' },
      { name: 'Tipos de Relación', path: '/config-empresas/tipos-relacion' },
      { name: 'Tamaños', path: '/config-empresas/tamanios' },
      { name: 'Sectores', path: '/config-empresas/sectores' },
      { name: 'Tipos de Documento', path: '/config-empresas/tipos-documento' },
    ],
  },
  {
    name: 'Config. Leads',
    icon: MENU_ICONS.config,
    moduleCode: ['settings', 'leads'],
    subItems: [
      { name: 'Tipos', path: '/config-leads/tipos' },
      { name: 'Ciclos', path: '/config-leads/ciclos' },
      { name: 'Razones Desc.', path: '/config-leads/razones-descalificacion' },
      { name: 'Atributos', path: '/config-leads/atributos' },
      { name: 'Reglas de Ciclo', path: '/config-leads/reglas' },
    ],
  },
  {
    name: 'Config. Negocios',
    icon: MENU_ICONS.config,
    moduleCode: ['settings', 'deals'],
    subItems: [
      { name: 'Etapas Pipeline', path: '/config-deals/ciclos' },
      { name: 'Orígenes', path: '/config-deals/origenes' },
      { name: 'Tipos de Negocio', path: '/config-deals/tipos-negocio' },
      { name: 'Prioridades', path: '/config-deals/prioridades' },
      { name: 'Roles de Contacto', path: '/config-deals/roles-contacto' },
      { name: 'Atributos Custom', path: '/config-deals/definiciones' },
    ],
  },
  {
    name: 'Config. Tareas',
    icon: MENU_ICONS.config,
    moduleCode: ['settings', 'tasks'],
    subItems: [
      { name: 'Tipos', path: '/tareas/config/tipos' },
      { name: 'Estados', path: '/tareas/config/estados' },
      { name: 'Prioridades', path: '/tareas/config/prioridades' },
      { name: 'Categorías', path: '/tareas/config/categorias' },
      { name: 'Motivos de cancelación', path: '/tareas/config/motivos-cancelacion' },
    ],
  },
  {
    name: 'Config. Tickets',
    icon: MENU_ICONS.config,
    moduleCode: ['settings', 'tickets'],
    subItems: [
      { name: 'Prioridades', path: '/tickets/config/priorities' },
      { name: 'Categorías', path: '/tickets/config/categories' },
      { name: 'Causas raíz', path: '/tickets/config/root-causes' },
      { name: 'Respuestas predefinidas', path: '/tickets/config/canned-responses' },
      { name: 'Vistas guardadas', path: '/tickets/config/saved-views' },
      { name: 'Pipelines', path: '/tickets/config/pipelines' },
      { name: 'Equipos', path: '/tickets/config/teams' },
      { name: 'Políticas de SLA', path: '/tickets/config/sla-policies' },
      { name: 'Reglas de asignación', path: '/tickets/config/assignment-rules' },
      { name: 'Reglas de escalación', path: '/tickets/config/escalation-rules' },
    ],
  },
  {
    name: 'Config. Reuniones',
    icon: MENU_ICONS.config,
    moduleCode: ['settings', 'meetings'],
    subItems: [
      { name: 'Tipos de reunión', path: '/meeting/config/meeting-types' },
      { name: 'Estados de reunión', path: '/meeting/config/meeting-statuses' },
      { name: 'Excepciones disponibilidad', path: '/meeting/config/availability-overrides' },
      { name: 'Motivos de cancelación', path: '/meeting/config/cancellation-reasons' },
      { name: 'Feriados', path: '/meeting/config/holidays' },
      { name: 'Plantillas de email', path: '/meeting/config/email-templates' },
      { name: 'Reglas de routing', path: '/meeting/config/routing-rules' },
    ],
  },
  // Administración del tenant (filtrada por rol en MenuVisibilityService).
  // 'Empresas' = administración de las empresas CLIENTE de la plataforma:
  // exclusiva de Super Admin (INC_CRM_024 inc02). Su módulo de permisos es
  // 'businesses' (V191); antes compartía 'settings' con los catálogos de
  // configuración, que Admin sí necesita, y por eso Admin la veía.
  { name: 'Empresas', path: '/businesses', icon: MENU_ICONS.business, moduleCode: 'businesses' },
  { name: 'Usuarios', path: '/users', icon: MENU_ICONS.user, moduleCode: 'users' },
  // Bandeja de quienes pidieron acceso desde la pagina publica (/signup). Vive en
  // administracion, no bajo "Invitaciones" de Comunicacion: AccessRequestController
  // se protege con requireSuperAdmin(), NO con el modulo 'users' de la matriz RBAC,
  // porque access_request es una tabla global sin businessId. Por eso va SIN
  // moduleCode; quien la ve lo decide MenuVisibilityService.isPathAllowed()
  // (/access-requests -> solo Super Admin).
  { name: 'Solicitudes de acceso', path: '/access-requests', icon: MENU_ICONS.invitacion },
  { name: 'Roles y permisos', path: '/roles', icon: MENU_ICONS.user, moduleCode: 'roles' },
  { name: 'Config. Correo', path: '/email-config', icon: MENU_ICONS.correo, moduleCode: 'mail' },
  { name: 'Políticas de canal email', path: '/admin/email-policies', icon: MENU_ICONS.correo },
  { name: 'Límites de envío (mi empresa)', path: '/config/email-limits', icon: MENU_ICONS.correo },
  {
    name: 'Monedas',
    icon: MENU_ICONS.moneda,
    // Catálogo global de la plataforma: la escritura sigue siendo Super Admin
    // (@RequiresRole en CurrencyController). 'settings' controla solo si se ve.
    moduleCode: 'settings',
    subItems: [
      { name: 'Monedas', path: '/currency' },
      { name: 'Programación', path: '/currency-job-configs' },
      { name: 'Historial', path: '/currency-job-executions' },
    ],
  },
  {
    name: 'Auditoría',
    icon: MENU_ICONS.auditoria,
    moduleCode: 'audit',
    subItems: [
      { name: 'Operaciones', path: '/audit/logs' },
      { name: 'Autenticación', path: '/audit/auth-logs' },
      { name: 'Configuración', path: '/audit/settings' },
    ],
  },
];

// ============================================================
// Lista plana de secciones (consumida por el buscador global)
// ============================================================

export const ALL_MENU_SECTIONS: { title: string; items: NavItem[] }[] = [
  { title: 'Comercio & Ventas',     items: SALES_ITEMS },
  { title: 'Comunicación',          items: COMMUNICATION_ITEMS },
  { title: 'Marketing',             items: MARKETING_ITEMS },
  { title: 'Automatización',        items: AUTOMATION_ITEMS },
  { title: 'Servicio al Cliente',   items: SERVICE_ITEMS },
  { title: 'Analítica y Reportes',  items: ANALYTICS_ITEMS },
  { title: 'Configuración',         items: CONFIG_ITEMS },
];